import script from "./NewsPagePopupTelegramBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPagePopupTelegramBlock.vue?vue&type=script&setup=true&lang=js"

import "./NewsPagePopupTelegramBlock.vue?vue&type=style&index=0&id=26181124&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26181124"]])

export default __exports__